import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useTranslation } from "react-i18next";

const ClaimsPenalties = ({
  sessionsPlayed,
  getSessionName,
  penalties,
  claims,
}: {
  sessionsPlayed: number[];
  getSessionName: (session: number) => string;
  penalties: PenaltiesGP[];
  claims: ClaimGP[];
}) => {
  const { t } = useTranslation();

  const getPenalties = (penalty: PenaltiesGP[], claim: ClaimGP) => {
    return penalty.map((penalty, index) => {
      return <p key={index}>{penaltyText(penalty)}</p>;
    });
  };
  const getPenaltiesJSX = (penalty: PenaltiesGP[], claim: ClaimGP) => {
    const penaltyCounts = penalty.reduce(
      (acc, curr) => {
        // Normalizamos el texto para poder comparar
        const normalizedDescription = curr.description
          .trim()
          .replace(/\.+$/, "")
          .toLowerCase();

        if (!acc[normalizedDescription]) {
          acc[normalizedDescription] = {
            description: curr.description.trim().replace(/\.+$/, ""),
            count: 0,
          };
        }

        acc[normalizedDescription].count++;

        return acc;
      },
      {} as Record<
        string,
        {
          description: string;
          count: number;
        }
      >,
    );

    return Object.values(penaltyCounts).map(({ description, count }, index) => {
      return <p key={index}>{description}</p>;
    });
  };
  const penaltyText = (penalty: PenaltiesGP) => {
    let penalty_text = "";
    if (penalty.type_penalty === 1) penalty_text = `+${penalty.value_penalty}s`;
    else if (penalty.type_penalty === 2)
      penalty_text = `-${penalty.value_penalty}pts`;
    else if (penalty.type_penalty === 3) penalty_text = `DQ`;
    else if (penalty.type_penalty === 4)
      penalty_text = `+${penalty.value_penalty} Qualy pos`;
    else if (penalty.type_penalty === 5) penalty_text = `Pit Lane Start`;
    else if (penalty.type_penalty === 6) penalty_text = `Championship Ban`;
    else if (penalty.type_penalty === 7) penalty_text = `Banned from LVF1`;
    else if (penalty.type_penalty === 8) penalty_text = `DQ Championship`;
    return penalty_text;
  };
  return (
    <div id="penalties-container" className="full-width">
      <label className="label-title-gp">
        {t("Claims").toUpperCase()} & {t("Penalties").toUpperCase()}
      </label>
      <div id="claim-penalty-container" className="column-around">
        {claims.length === 0 && penalties.length === 0 && (
          <p>{t("NoClaimsForThisRace")}</p>
        )}
        <div className="claims-penalties-container">
          {/* RECLAMACIONES */}
          {claims.map((claim, index) => {
            const claimPenalties = penalties.filter(
              (penalty) => penalty.claim_id === claim.claim_id,
            );

            return (
              <div
                className={`claim-penalty-card ${claimPenalties.length > 0 ? "direct-penalty" : ""}`}
                key={`claim-${claim.claim_id}`}
              >
                {/* Número */}
                <div className="claim-penalty-number">
                  <span>#C{index + 1}</span>
                </div>
                {/* Información */}
                <div className="claim-penalty-info">
                  <div className="claim-penalty-title">
                    <span className="claim-type">{t("Claim")}</span>

                    <span className="claim-offender">{claim.username}</span>
                  </div>

                  <div className="claim-penalty-details">
                    <div className="claim-detail">
                      <i className="fa fa-clock-o" />
                      <span>{claim.time}</span>
                    </div>

                    <div className="claim-detail">
                      <i className="fa fa-flag-checkered" />
                      <span>{getSessionName(claim.session)}</span>
                    </div>
                  </div>

                  <div className="claim-penalty-description">
                    {/* Sanciones asociadas */}
                    {claimPenalties.length > 0 && (
                      <div className="claim-penalties-list">
                        {getPenaltiesJSX(claimPenalties, claim)}
                      </div>
                    )}
                  </div>
                </div>
                {/* Indicador */}
                {claimPenalties.length > 0 ? (
                  <div className="claim-penalty-points">
                    <div>{getPenalties(claimPenalties, claim)}</div>
                  </div>
                ) : (
                  <div className="claim-penalty-points">
                    <div>
                      <span className="pending">
                        {claim.reviewed === 1 ? "NFA" : t("Pending")}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
          {/* SANCIONES DIRECTAS */}
          {penalties
            .filter((penalty) => penalty.claim_id === null)
            .map((penalty, index) => {
              return (
                <div
                  className="claim-penalty-card direct-penalty"
                  key={`penalty-${penalty.id ?? index}`}
                >
                  {/* Número */}
                  <div className="claim-penalty-number">
                    <span>#S{index + 1}</span>
                  </div>

                  {/* Información */}
                  <div className="claim-penalty-info">
                    <div className="claim-penalty-title">
                      <span className="claim-type">{t("Penalty")}</span>

                      <span className="claim-offender">{penalty.driver}</span>
                    </div>

                    <div className="claim-penalty-description">
                      {penalty.description}
                    </div>
                  </div>

                  {/* Penalización */}
                  <div className="claim-penalty-points">
                    <div>{penaltyText(penalty)}</div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default ClaimsPenalties;
